import { Card } from "@/components/ui/card";

export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">{title}</h1>
        {subtitle && <p className="text-muted-foreground text-sm mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function StatCard({ label, value, sub, icon: Icon, accent }) {
  return (
    <Card className="p-5 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between">
        <p className="text-xs uppercase tracking-[0.15em] text-muted-foreground">{label}</p>
        {Icon && (
          <span className={`${accent ? "text-accent" : "text-primary"}`}>
            <Icon className="w-4 h-4" strokeWidth={1.6} />
          </span>
        )}
      </div>
      <p className="font-display text-2xl font-bold mt-2 tracking-tight">{value}</p>
      {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
    </Card>
  );
}

export function Empty({ children }) {
  return (
    <div className="text-center py-16 text-muted-foreground text-sm" data-testid="empty-state">
      {children}
    </div>
  );
}
